import { render } from "./A_Planner_Y.vue?vue&type=template&id=5a15aaff&scoped=true"
import script from "./A_Planner_Y.vue?vue&type=script&lang=js"
export * from "./A_Planner_Y.vue?vue&type=script&lang=js"

import "./A_Planner_Y.vue?vue&type=style&index=0&id=5a15aaff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a15aaff"]])

export default __exports__